import Vue from 'vue'

function getOrigenFromResponse(response) {
    if (!response || !response.data) {
        return null
    }

    return response.data.data || response.data.origen || response.data
}

export async function getOrigenes(context, [access_token, con_loading]) {
    
    try {
        if (access_token) {
            if (con_loading){
                context.commit('setLoading', true, { root: true })
            }
            const response = await Vue.axios({
                method: 'GET',
                url: '/origenes',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })
           
            context.commit('origenes/setOrigenes', response.data.data, { root: true })
        }

    } catch (e) {
    } finally {
        if (con_loading){
            context.commit('setLoading', false, { root: true })
        }
    }
}

export async function crearOrigen(context, [access_token, modelOrigen]) {
    try {

        if (access_token) {
           // context.commit('setLoading', true, { root: true })
            const response = await Vue.axios({
                method: 'POST',
                url: '/origenes',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: modelOrigen
            })
            return response;
         
          
        }

    } catch (e) {
    } finally {
     //  context.commit('setLoading', false, { root: true })
    }
}

export async function crearUsuarioOrigen(context, [access_token, modelUsuario]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'POST',
                url: '/origenes/usuarios',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: modelUsuario
            })
            return response;
        }
    } catch (e) {
        return e.response;
    }
}

export async function updateOrigen(context, [access_token, modelOrigen]) {
    try {
        if (access_token) {
          
            const response = await Vue.axios({
                method: 'PUT',
                url: '/origenes/' + modelOrigen.id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: modelOrigen
            })
            if (response.status == 200) {
                context.commit('origenes/actListOrigenes', response.data.data, { root: true })
                context.commit('grupos/actListOrigenesFromGrupos', response.data.data, { root: true })
            }
           return response;
           // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
     // context.commit('setLoading', false, { root: true })
    }
}

export async function getOrigen(context, [access_token, origen_id, con_loading]) {
    try {
        if (access_token) {
            if (con_loading) {
                context.commit('setLoading', true, { root: true })
            }

            let response = null

            try {
                response = await Vue.axios({
                    method: 'GET',
                    url: '/origenes/' + origen_id,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': 'Bearer ' + access_token,
                    },
                })
            } catch (e) {
                if (!e.response || e.response.status !== 404) {
                    throw e
                }

                response = await Vue.axios({
                    method: 'GET',
                    url: '/origenes/' + origen_id,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': 'Bearer ' + access_token,
                    },
                })
            }

            const origen = getOrigenFromResponse(response)

            if (response.status == 200 && origen && origen.id) {
                context.commit('origenes/setOrigenSelec', origen, { root: true })
                context.commit('origenes/actListOrigenes', origen, { root: true })
                context.commit('grupos/actListOrigenesFromGrupos', origen, { root: true })
            }

            return response
        }

    } catch (e) {
        return e.response
    } finally {
        if (con_loading) {
            context.commit('setLoading', false, { root: true })
        }
    }
}

export async function updateOrigenIsActive(context, [access_token, origen_id, is_active]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'PUT',
                url: '/origenes/' + origen_id + '/is-active',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    is_active
                }
            })
            if (response.status == 200 && response.data && response.data.origen) {
                context.commit('origenes/actListOrigenes', response.data.origen, { root: true })
                context.commit('grupos/actListOrigenesFromGrupos', response.data.origen, { root: true })
            }
            return response;
        }
    } catch (e) {
        return e.response;
    }
}

export async function updateOrigenGrupo(context, [access_token, origen_id, grupo_id]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'PUT',
                url: '/origenes/' + origen_id + '/grupo',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    grupo_id
                }
            })
            const origenActualizado = response.data && (response.data.origen || response.data.data || response.data)
                ? (response.data.origen || response.data.data || response.data)
                : null;

            if (response.status == 200 && origenActualizado && origenActualizado.id) {
                context.commit('origenes/actListOrigenes', origenActualizado, { root: true })
            }
            return response;
        }
    } catch (e) {
        return e.response;
    }
}

export async function updateUserIsActive(context, [access_token, user_id, is_active]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'PUT',
                url: '/users/' + user_id + '/is-active',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    is_active
                }
            })
            return response;
        }
    } catch (e) {
        return e.response;
    }
}

export async function enviarCredencialesUsuario(context, [access_token, user_id, origen_id]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'POST',
                url: '/enviar-credenciales/' + user_id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    origen_id
                }
            })
            if (response.status == 200 && response.data && response.data.origen) {
                context.commit('origenes/actListOrigenes', response.data.origen, { root: true })
                context.commit('grupos/actListOrigenesFromGrupos', response.data.origen, { root: true })
            }
            return response;
        }
    } catch (e) {
        return e.response;
    }
}

export async function eliminarOrigen(context, [access_token, origen_id]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'DELETE',
                url: '/origenes/' + origen_id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })

          
           if (response.status == 200) {
            context.commit('origenes/actDeleteListOrigenes', origen_id, { root: true })
            context.commit('grupos/actDeleteListOrigenesFromGrupos', origen_id, { root: true })
           }
           return response;
          
           // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
      // context.commit('setLoading', false, { root: true })
    }
}
